import { useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import firstImg from "./images/sebastian-svenson-LpbyDENbQQg-unsplash.jpg";
import secondImg from "./images/ilgmyzin-_ZZ0KTqKv5g-unsplash.jpg";
import thirdImg from "./images/simon-lee-egWTpKFu8rU-unsplash.jpg";
import { useNavigate } from "react-router-dom";
import "./Carousel.css";

function ControlledCarousel() {
  let navigate = useNavigate();
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex: number) => {
    setIndex(selectedIndex);
  };

  return (
    <Carousel activeIndex={index} onSelect={handleSelect}>
      <Carousel.Item onClick={() => navigate("about-us")}>
        <img className="d-block w-100 img" src={firstImg} alt="First slide" />
        <Carousel.Caption>
          <h2>Kai Tsz Technology</h2>
          <h4>Transforming your digital presence with innovative solutions</h4>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item onClick={() => navigate("web-development")}>
        <img className="d-block w-100 img" src={secondImg} alt="Second slide" />

        <Carousel.Caption>
          <h2>Website Design & Development</h2>
          <h4>Crafting custom websites that elevate your brand</h4>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item onClick={() => navigate("app-development")}>
        <img className="d-block w-100 img" src={thirdImg} alt="Third slide" />

        <Carousel.Caption>
          <h2>Mobile App Development</h2>
          <h4>Innovative mobile solutions for the future</h4>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
}

export default ControlledCarousel;
